import { v4 as uuid } from "uuid";
import { client } from "../../../../hooks/Client";

/**
 * @param {string} reportId The ID of the report to view
 * @param {boolean} [isTemplate] When true, marks the URL as a template view —
 *   the breadcrumb reads this to show the template variant. The page itself
 *   derives template-ness from the report document, not from this param.
 * @returns A link to the viewer page
 */
export const getViewerUrl = (reportId, isTemplate = false) => {
    return `/${client}/livereporttemplateviewer/${reportId}${isTemplate ? '?template=true' : ''}`;
}

/**
 * Het printvel van een rapportage (de pagina achter 'PDF maken'). Leest het
 * rapport-ID op positie 3, net als de viewer.
 * @param {string} reportId The ID of the report to print
 * @returns A link to the print page
 */
export const getPrintUrl = (reportId) => {
    return `/${client}/livereportprint/${reportId}`;
}

/**
 * @param {string} reportId The ID of the report to open publicly
 * @returns A link to the public open page
 */
export const getOpenUrl = (reportId) => {
    return `/${client}/livereportopen2/${reportId}`;
}

/**
 * @param {string|null} [reportId] The ID of the report to open, null for a new report
 * @param {boolean} [template] Whether to open as 'template' builder 
 * @param {string|null} [copyOfReportTemplateId] If provided, the editor will load the given report as a template (overrides 'template' param)
 * @returns A link to the editor page
 */
export const getEditorUrl = (reportId = null, template = false, copyOfReportTemplateId = null) => {

    const s = new URLSearchParams();

    if (template) {
        s.set('template', 'true');
    }

    if (copyOfReportTemplateId) {
        s.set('copyOf', copyOfReportTemplateId);
    }

    if (!reportId) {
        reportId = uuid(); // Generate a new report ID if not provided
    }

    return `/${client}/livereporttemplatebuilder/${reportId}?${s.toString()}`;
}
